import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { DepartmentService } from '../../services/department.service';
import { EmployeeService } from '../../services/employee.service';

import { Utils } from '../../util';
import { toast } from 'angular2-materialize';

@Component({
    selector: 'app-display-department',
    templateUrl: './display-department.component.html',
    styleUrls: ['./display-department.component.css', '../../app.component.css']
})

export class DisplayDepartmentComponent implements OnInit {

    department: any = [];

    id: string;

    igdSubs: any;
    igeSubs: any;

    constructor(private router: Router,
                private activatedRoute: ActivatedRoute,
                private departmentService: DepartmentService,
                private employeeService: EmployeeService) {
        this.activatedRoute.params.subscribe(parameters => {
            this.id = parameters['id'];

            this.igdSubs = this.departmentService.getDepartment(this.id).subscribe(departmentObj => {
                this.igdSubs.unsubscribe();

                this.department = departmentObj;

                if (this.department.responsibleId) {
                    this.igeSubs = this.employeeService.getEmployee(this.department.responsibleId).subscribe(responsibleObj => {
                        this.igeSubs.unsubscribe();
                        if(responsibleObj.active != 1) return toast('El empleado responsable fue borrado de la base de datos.', 5000);
                        this.department.responsibleName = responsibleObj.name + ' ' + responsibleObj.lastName;
                    });
                }

                if (this.department.applyInPrompterReport !== undefined) {
                    this.department.applyInPrompterReport = (this.department.applyInPrompterReport) ? 'Sí' : 'No';
                }
                if (this.department.applyInSupervisorReport !== undefined) {
                    this.department.applyInSupervisorReport = (this.department.applyInSupervisorReport) ? 'Sí' : 'No';
                }
                if (this.department.applyInCheckClock !== undefined) {
                    this.department.applyInCheckClock = (this.department.applyInCheckClock) ? 'Sí' : 'No';
                }
                if (this.department.applySecurityReport !== undefined) {
                    this.department.applySecurityReport = (this.department.applySecurityReport) ? 'Sí' : 'No';
                }
            });
            
        });
    }

    ngOnInit() {

    }

}
